// src/containers/VehicleList/VehicleDisplay/VehicleTab/MpiFormBuilder/components/ChecklistLegend.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const EXCLUDED_FIELDS = ['name', 'description']; // ← Fields to exclude from legend

const ChecklistLegend = ({ allHeaders }) => {
  const uniqueHeaders = React.useMemo(() => {
    const map = new Map();

    allHeaders.forEach(sectionHeaders => {
      sectionHeaders.forEach(h => {
        // Skip excluded fields
        if (EXCLUDED_FIELDS.includes(h.field)) return;

        const parts = h.label.split(':').map(p => p.trim());
        const cleanLabel = parts[0];
        const icon = parts.length > 1 ? parts[1] : null;
        const true_color = parts.length > 2 ? parts[2] : '#666';

        if (icon && cleanLabel) {
          const key = `${cleanLabel}-${icon}`;
          if (!map.has(key)) {
            map.set(key, {
              label: cleanLabel,
              icon,
              color: true_color,
            });
          }
        }
      });
    });

    return Array.from(map.values());
  }, [allHeaders]);

  if (uniqueHeaders.length === 0) return null;

  return (
    <Box sx={{ mt: 2, py: 2, px: 2 }}>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 3,
          flexWrap: 'wrap',
          pr: 2,
        }}
      >
        {uniqueHeaders.map((h, idx) => (
          <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <i
              className={`far fa-${h.icon}`}
              style={{ fontSize: '26px', color: h.color }}
              aria-hidden="true"
            />
            <Typography variant="body2" sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
              {h.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ChecklistLegend;